import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap"; 

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

class List extends Component {
  
  constructor(props)
  {
    super(props);
    this.state = {
      list:'',
      confirmDelete:null,
    };
    

    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  
    }

    

    componentDidMount() {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id,
      };  

      axios.post(apiUrl+"rolesmanagement/list",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){
         
            this.setState({  list: res.data.list, totalRecord: res.data.records_count}, function() {
            
              this.list();
            });
  
        }
      }); 
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id,
     };
    //  this.props.getlist(qs.stringify(postobject))
    axios.post(apiUrl+"rolesmanagement/list",qs.stringify(postobject)).then(res => {
      
      if(res.data.status === 'success'){
          this.setState({  list: res.data.list, totalRecord: res.data.records_count}, function() {
            this.list();
          });

      }
    }); 

   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id,  
  };
  // console.log(postObject);
  // this.props.getlist(qs.stringify(postObject));
  axios.post(apiUrl+"rolesmanagement/list",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){

        this.setState({  list: res.data.list, totalRecord: res.data.records_count}, function() {
          this.list();
        });

    }else{
      this.setState({  list: '', totalRecord: ''}, function() {
        this.list();
      });

    }
  }); 

} 



   componentWillReceiveProps(Props){

     if (Props.deleterolesmanagement!== this.props.deleterolesmanagement) {
      if (Props.deleterolesmanagement[0]["status"] === "success") {
         
          $('.success_message').html('<div class="status_sucess"><h3>'+ Props.deleterolesmanagement[0]["message"]+'</h3></div>');
           var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              // this.props.getlist(qs.stringify(postobject));
              axios.post(apiUrl+"rolesmanagement/list",qs.stringify(postobject)).then(res => {
                if(res.data.status === 'success'){
           
                    this.setState({  list: res.data.list, totalRecord: res.data.records_count}, function() {
                      this.list();
                    });
          
                }
              }); 
           setTimeout(
          function() {
          $('.success_message').html('');
          //window.location.reload(); 
          }
          .bind(this),
          3000
          );


          this.setState({list: Props.deleterolesmanagement[0]["list"]}, function() {
            this.list();
          });       
          }
          
      }

       if(Props.rolesmanagementactive !== this.props.rolesmanagementactive){
      if (Props.rolesmanagementactive[0]["status"] === "success") {

        $('.success_message').html('<div class="status_sucess"><h3>'+ Props.rolesmanagementactive[0]["message"]+'</h3></div>');
              var qs = require('qs');
              var admin_id = localStorage.getItem("admin_id");
              var postobject = {
              activePage: 1,
              search_all: '',
              admin_id: admin_id
              };

              // this.props.getlist(qs.stringify(postobject));
               axios.post(apiUrl+"rolesmanagement/list",qs.stringify(postobject)).then(res => {
    if(res.data.status === 'success'){

        this.setState({  list: res.data.list, totalRecord: res.data.records_count}, function() {
          this.list();
        });

    }
  }); 


           
           setTimeout(
          function() {
          $('.success_message').html('');
          //window.location.reload(); 
          }
          .bind(this),
          3000
          );

      }
    }
     
   }
   
  
deleteConfirm=(confirmstatus,id)=>{
  
  if(confirmstatus == 'yes'){
    $('.confirm-action-delete').removeClass('show');
    var qs = require('qs');
    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      id  :id
    };

    axios.post(apiUrl+"rolesmanagement/delete",qs.stringify(postObject)).then(res => {
      if(res.data.status === 'success'){       
            window.location.reload(); 
      }
    });  
  }else{
    $('.confirm-action-delete').removeClass('show');	
  }
}  
deletecategory(id){
  this.setState({confirmDelete : id})
  $('.confirm-action-delete-message').html('Are you sure delete this role?');	
  $('.confirm-action-delete').addClass('show');	
 }
activaterolesmanagement(id, status){
  let stat = ''
    if(status == 'Inactive'){
      stat = "A";
    }else{
      stat = "I";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id,
          status: stat
        };

      axios.post(apiUrl+"rolesmanagement/change_status",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          window.location.reload(false);
        }
      }); 
}


list() {
    var list = this.state.list;
    if (list != "undefined" && list != null) {
    

      if (list.length > 0) {

        if (Object.keys(list).length > 0) {
          const helperlistDetails = list.map(
            (list, Index) => {
              let sno = Index+1;
              

               if(list.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
            
              return (
                <tr key={list.id}>
      					<td>{sno}</td>
      					<td>{list.name}</td>
      				
      					{/* <td>{list.quantity}</td> */}
      					{/* <td>{list.description}</td> */}
                <td>{status}</td>
                <td className="actiongroup" >
                    {/*  <Link to={{ pathname: '/rolesmanagement-view/'+list.id}} className="" title="View">  <i className="ft-eye" aria-hidden="true"></i></Link>
                    <Link to={{ pathname: '/rolesmanagement-edit/'+list.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link> */}
                     <Link to={{ pathname: '/rolemanagement-edit/'+list.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    {(status == 'Active'?<Link onClick={this.activaterolesmanagement.bind(this, list.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activaterolesmanagement.bind(this, list.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}      
        
                    
                     <Link onClick={this.deletecategory.bind(this,list.id)} className="" title="Duplicate"><i className="ft-trash-2" aria-hidden="true"></i></Link>
                    
                  </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="7" className="v-align-nr" style={{textAlign:"center"}}>
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="7" className="v-align-nr" style={{textAlign:"center"}}>
            No Result
          </td>
        </tr>
      );
    }
  }
  
  cloneConfirm =(confirmstatus)=>{
    if(confirmstatus == 'yes'){
			this.clonerolesmanagement(this.state.rolesmanagementid);
			$('.confirm-action').removeClass('show');
		}else{
			$('.confirm-action').removeClass('show');	
		}
  }

  clonerolesmanagement(id){
    var admin_id = localStorage.getItem('admin_id');
    axios.get(apiUrl+'rolesmanagement/setrolesmanagementcopy?admin_id='+admin_id+'&id='+id)
    .then(res => {
    if(res.data.status === 'success'){
      // window.location.reload(); 
    }
    });
  }


  render() {

    const {domainlist,universitynamelist} = this.state;
	  var current = this;
    var admin_id = localStorage.getItem('admin_id');
   let catImg = '';
  let preview = '';
    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="rolemanagement" /> 
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>
   
         <div className="car-listing-wrap leaa-admin-head card">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>{(this.state.totalRecord>0&&this.state.totalRecord!='')&&this.state.totalRecord}{' '}
                   Role Management</h3>
                </div>
               
          
                 <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                 <div className="add_button">  
                    <a className="" href='/rolemanagement-add'>Add</a>
                </div>
                </div>      
                         
              <div style={{color:"green", fontSize: 30}} className="statusmessage"></div>
            
              <div className="car-listing-row table-avrech">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
			            <th>Name</th>
			            {/* <th>Description</th> */}
                  <th>Status</th>
                  <th style={{width:"100px"}}>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.list()}</tbody>
                </Table>
			        	</div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>
          
            </div> 
        </div>  
      </div>
      <div className="confirm-action-delete">
        <p className="confirm-action-delete-message"></p>
        <a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.confirmDelete)} className="btn">Yes</a>
        <a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
        <span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
      </div>
    </div>
    );
  }
}
export default (withRouter(List));